// downloadMixin.js
export const menuMixin = {
  methods: {
    downloadFile (url, fileName) {
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    // 复制链接到剪贴板的方法
    copyLinkToClipboard (url) {
      try {
        navigator.clipboard.writeText(url)
      } catch (err) {
        this.fallbackCopyLinkToClipboard(url)
      }
    },
    fallbackCopyLinkToClipboard (url) {
      const textArea = document.createElement('textarea')
      textArea.value = url

      // 设置文本域的样式，使其不可见
      textArea.style.display = 'none'

      // 将文本域添加到DOM中
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        document.execCommand('copy')
      } catch (err) {
      }

      // 移除文本域
      document.body.removeChild(textArea)
    }
  }
}

// downloadMixin.js
export const CommonMixin = {
  methods: {
    appFn (params, elseCb, appCb) {
      if (this.$route.query && this.$route.query.platform === 'app') {
        window.fangcloud && window.fangcloud.postMessage(JSON.stringify(params))
        typeof appCb === 'function' && appCb()
      } else {
        elseCb()
      }
    }
  }
}
